import { useEffect } from "react";

/**
 * Lightweight SEO hook — updates document.title and meta description dynamically.
 * Falls back to canonical brand title/description when a page unmounts.
 */
const BRAND = "1001 Mimarlık İnşaat ve Ticaret A.Ş.";
const DEFAULT_TITLE = BRAND;
const DEFAULT_DESCRIPTION =
  "1001 Mimarlık İnşaat ve Ticaret A.Ş. — Mimarlık, inşaat taahhüt, anahtar teslim proje ve gayrimenkul geliştirme alanlarında kurumsal çözümler.";

function upsertMeta(name, content, attr = "name") {
  if (!content) return null;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  const prev = el.getAttribute("content");
  el.setAttribute("content", content);
  return { el, prev };
}

export function useDocumentSEO({ title, description, ogTitle, ogDescription }) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ? `${title} | ${BRAND}` : DEFAULT_TITLE;

    const prevs = [
      upsertMeta("description", description || DEFAULT_DESCRIPTION),
      upsertMeta("og:title", ogTitle || title || BRAND, "property"),
      upsertMeta(
        "og:description",
        ogDescription || description || DEFAULT_DESCRIPTION,
        "property"
      ),
    ].filter(Boolean);

    return () => {
      document.title = prevTitle;
      prevs.forEach((entry) => {
        if (entry?.el && entry?.prev != null) {
          entry.el.setAttribute("content", entry.prev);
        }
      });
    };
  }, [title, description, ogTitle, ogDescription]);
}
